var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';
import { SpinnerColorScheme } from '@amzn/atoz-web/Spinner';
import { useBreakpoints } from '@amzn/atoz-web/Responsive';
import { ButtonVariant } from '@amzn/atoz-web/Button';
import { Col } from '@amzn/atoz-web/Col';
import { Row } from '@amzn/atoz-web/Row';
import { Text } from '@amzn/atoz-web/Text';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
import { ModalContent } from '@amzn/atoz-web/Modal';
import { View } from '@amzn/atoz-web/View';
import { getTimeIntervalStr, formatDuration } from '@amzn/atoz-shiftapp-utilities';
import { LoadingButton } from '../../../shared';
import { gql } from '@apollo/client';
import { logger } from '@amzn/atoz-shiftapp-metrics';
var ShiftSwapReviewItem = function (_a) {
    var startTime = _a.startTime, endTime = _a.endTime, siteId = _a.siteId;
    var intervalStr = getTimeIntervalStr(startTime, endTime);
    var durationStr = formatDuration(endTime.diff(startTime, ['hours', 'minutes']), true);
    return (React.createElement(SwapShiftContainer, null,
        React.createElement(Row, null,
            React.createElement(Text, { fontWeight: "bold" }, "".concat(intervalStr, " (").concat(durationStr, ")"))),
        React.createElement(Row, null,
            React.createElement(Text, null, siteId))));
};
export var ACCEPT_SWAP_MUTATION = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation AcceptSwap($manageSwapInput: ManageSwapInput!) {\n        acceptSwap(input: $manageSwapInput)\n    }\n"], ["\n    mutation AcceptSwap($manageSwapInput: ManageSwapInput!) {\n        acceptSwap(input: $manageSwapInput)\n    }\n"])));
export var InstantSwapSingleShiftConfirmationModalContent = function (_a) {
    var originalShift = _a.originalShift, newShift = _a.newShift, siteId = _a.siteId, confirmInstantSwap = _a.confirmInstantSwap, closeModal = _a.closeModal, loading = _a.loading;
    var t = useTranslation().t;
    var matches = useBreakpoints().matches;
    if (!newShift || !Object.keys(newShift).length) {
        logger.emitError('Instant swap could not be completed because no new shift was selected');
        return null;
    }
    var parsedOriginalStart = DateTime.fromISO(originalShift.start);
    var parsedOriginalEnd = DateTime.fromISO(originalShift.end);
    var parsedNewStart = DateTime.fromISO(newShift.timeRange.start);
    var parsedNewEnd = DateTime.fromISO(newShift.timeRange.end);
    var shiftDateDisplayOptions = {
        weekday: 'short',
        month: 'short',
        day: '2-digit',
        year: 'numeric'
    };
    var originalShiftDate = parsedOriginalStart
        .toLocaleString(shiftDateDisplayOptions)
        .toUpperCase();
    var newShiftDate = parsedNewStart
        .toLocaleString(shiftDateDisplayOptions)
        .toUpperCase();
    return (React.createElement(ModalInner, { desktopView: !matches.s },
        React.createElement(ModalContent, { titleText: t('shift_management_features_InstantSwapConfirmationModal_title'), dataTestId: "InstantSwapSingleShiftConfirmationModalContent", onCloseButtonClick: closeModal, closeButtonAltText: t('shift_management_common_closeModalButton') },
            React.createElement(Col, { gridGap: "S300" },
                React.createElement(Text, { fontSize: "T400", fontWeight: "medium", role: "heading", "aria-level": 3 }, t('shift_management_features_InstantSwapConfirmationModal_originalShiftSubtitle')),
                React.createElement(Text, null, originalShiftDate),
                React.createElement(ShiftSwapReviewItem, { startTime: parsedOriginalStart, endTime: parsedOriginalEnd, siteId: siteId }),
                React.createElement(Text, { fontSize: "T400", fontWeight: "medium", role: "heading", "aria-level": 3 }, t('shift_management_features_InstantSwapConfirmationModal_newShiftSubtitle')),
                React.createElement(Text, null, newShiftDate),
                React.createElement(ShiftSwapReviewItem, { startTime: parsedNewStart, endTime: parsedNewEnd, siteId: siteId }),
                React.createElement(LoadingButton, { key: "LegacyInstantSwapConfirmButton", buttonVariant: ButtonVariant.Primary, onClick: confirmInstantSwap, dataTestId: "LegacyInstantSwapConfirmButton", loading: loading, spinnerColor: SpinnerColorScheme.Inverted, buttonText: t('shift_management_features_InstantSwapConfirmationModal_confirm') })))));
};
var SwapShiftContainer = styledWithTheme(View)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var theme = _a.theme;
    return "\n    background: ".concat(theme.selectors.color('neutral10'), "};\n    padding: ").concat(theme.selectors.space('S400'), "px;\n    ");
});
var ModalInner = styledWithTheme('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var desktopView = _a.desktopView;
    return desktopView && "width: 544px;";
});
var templateObject_1, templateObject_2, templateObject_3;
